import { render, staticRenderFns } from "./TypeLabel.vue?vue&type=template&id=317aca14&scoped=true"
import script from "./TypeLabel.vue?vue&type=script&lang=ts"
export * from "./TypeLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317aca14",
  null
  
)

export default component.exports